import { ReactNode, useEffect, useState } from "react"
import translate from '../../utils/translations/Translations'
import { Skeleton } from "@mui/material"

interface MusicKitProviderProps {
    children: ReactNode
}
  
  
const MusicKitProvider = (props: MusicKitProviderProps) => {
    const [ready, setReady] = useState(false)
  
    useEffect(() => {
        const initMK = async () =>  { 

            const mk = MusicKit.configure({
                developerToken: 'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkM3NzZTTTdKUFEifQ.eyJpYXQiOjE3NjQ2Nzk1NTIsImV4cCI6MTc4MDIzMTU1MiwiaXNzIjoiRDYzUURROUg5VCJ9.XY4MVa9i2GLU815a_bk04dPkhD8MsAWhstTF_pxIkMUoIbA0DPNyYT1yssD-fwenATwgeINesU5CzHjvpAq8ZA',
                app: {
                name: 'Meka',
                icon: '',
                build: '1.0beta1',
                version: '1.0beta1',
                },
                bitrate: MusicKit.PlaybackBitrate.HIGH,
            })

            const setLanguage = (countryCode: string = 'fr') => {
                translate.setLanguage(countryCode);
                //forceUpdate()
            }
    
            setLanguage(mk.storekit?.storefrontCountryCode)
    
            // const handler = (e: any) => {
            //     setLanguage(e.storefrontCountryCode);
            // }
    
            // mk.addEventListener(
            //     'storefrontCountryCodeDidChange',
            //     handler as () => void,
            // )  
    
            setReady(true)
        }

        initMK()
        .catch(console.error)

    }, [])
  

    if (!ready) {
        return <Skeleton sx={{height: '50vh'}}/>
    }
    
    return props.children
  
}

export default MusicKitProvider

